document.addEventListener("DOMContentLoaded", function () {
	if (document.querySelectorAll(".mdig-video-button").length > 0) {
		const videoButtons = document.querySelectorAll(".mdig-video-button");

		videoButtons.forEach(function (video) {
			const playButton = video.parentElement.querySelector(
				".mdig-video-play-button",
			);

			if (playButton) {
				playButton.addEventListener("click", function () {
					if (video.paused) {
						video.play();
						video.setAttribute("controls", "controls");
						playButton.style.display = "none";
					}
				});

				video.addEventListener("ended", function () {
					playButton.style.display = "flex";
					video.removeAttribute("controls");
				});

				video.addEventListener("pause", function () {
					playButton.style.display = "flex";
					video.removeAttribute("controls");
				});
			}
		});
	}
});
